module.exports = __webpack_public_path__ + "4bc5c6cbaf22c0296f023524f594bf78.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/applications/assign/assign-group-to-application.html
// module id = 2093
// module chunks = 0